// extracted by mini-css-extract-plugin
module.exports = {"toDoLists":"ToDoLists_toDoLists__1tssY","addToDoList":"ToDoLists_addToDoList__XkqYe"};